<template>
  <div class="tusd-wrap wrap-bg">
    <div class="page-title">
      <i class="back-btn" @click="goBack(0)"></i>订单详情
    </div>
      <div class="order-details clearfix">
        <div class="user-order">
          <div class="user-header">
            <!-- <div class="header-wrap"></div> -->
            <img v-if="order.PayType == 1" class="order_icon" src="../assets/images/bankIcon.png" alt="">
				    <img v-if="order.PayType == 2" class="order_icon" src="../assets/images/alipayIcon.png" alt="">
          </div>
          <div class="order-amount-time">
            <!-- <div class="order-amount">{{common.toDecimal2(order.USDT)}} USDT</div> -->
            <!-- <div class="order-time"><span>交易 10</span>&nbsp;&nbsp;<span>好评 {{order.buyerScore}}%</span></div> -->
          </div>
        </div>
        <div class="order-money">
          <div class="order-money-title">金额</div>
          <div class="order-money-amount">
            <span  v-clipboard:copy="order.Amount" v-clipboard:success="copySuccess" v-clipboard:error="copyError">{{common.toDecimal2(order.CNY)}}</span>CNY
          </div>
        </div>
      </div>
      <div class="separator"></div>
      <div class="order-info">
        <div class="page-item">
          <span class="page-item-label">下单时间：</span>
          <span class="page-item-content">{{common.formatDate( order.OrderTime) }}</span>
        </div>
        <div class="page-item">
          <span class="page-item-label">系统订单号：</span>
          <span class="page-item-content"
             v-clipboard:copy="order.OrderNo"
            v-clipboard:success="copySuccess"
            v-clipboard:error="copyError"
          >{{order.OrderNo}}</span>
        </div>
        <div class="page-item">
          <span class="page-item-label">商户订单号：</span>
          <span class="page-item-content"
             v-clipboard:copy="order.MchOrder"
            v-clipboard:success="copySuccess"
            v-clipboard:error="copyError"
          >{{order.MchOrder}}</span>
        </div>
        <div class="page-item">
          <span class="page-item-label">收款方式：</span>
          <span class="page-item-content"
             v-clipboard:copy="order.BankName"
            v-clipboard:success="copySuccess"
            v-clipboard:error="copyError"
          >{{order.BankName}}</span>
        </div>
        <div class="page-item">
          <span class="page-item-label">收款账号：</span>
          <span class="page-item-content"
            v-clipboard:copy="order.BankAccount"
            v-clipboard:success="copySuccess"
            v-clipboard:error="copyError"
          >{{order.BankAccount}}</span>
        </div>
        <div class="page-item" v-if="order.PayType == 1">
          <span class="page-item-label">开户行：</span>
          <span class="page-item-content"
           v-clipboard:copy="order.BankAddress"
            v-clipboard:success="copySuccess"
            v-clipboard:error="copyError"
          >{{order.BankAddress}}</span>
        </div>
        <div class="page-item">
          <span class="page-item-label">收款人：</span>
          <span class="page-item-content"
           v-clipboard:copy="order.BankUser"
            v-clipboard:success="copySuccess"
            v-clipboard:error="copyError"
          >{{order.BankUser}}</span>
        </div>
          <div class="page-item">
          <span class="page-item-label">状态：</span>
          <span class="page-item-content">{{common.getOrderStatus(order.Status)}}</span>
        </div>
        <div class="page-item"  v-if="order.Status!=1">
          <span class="page-item-label">备注：</span>
          <span class="page-item-content">{{order.PersonalRemark}}</span>
        </div>
        <div class="page-item" v-if="order.Status==1">
          <span  style="color: red;">* 转账时，请仔细核对转账信息填写是否正确。</span>
        </div>
        <div class="page-item" v-if="order.Status==1 && order.PayType == 1">
          <span  style="color: red;">* 银行转账时，请不要在“附言”里填写备注内容。</span>
        </div>
      </div>

      <div class="auth-upload" v-if="order.Status==1">
        <div class="upload-title">上传支付凭证</div>
        <div class="upload-wrap">
          <cube-upload
            class="box-wrap"
            ref="frontUpload"
            v-model="auth.file1"
            :auto="false"
            :max="1"
            @files-added="filesAdded"
            @file-success="successFront"
            @file-error="errFront"
          >
            <div class="clearfix">
              <cube-upload-file v-for="(file, i) in auth.file1" :file="file" :key="i"></cube-upload-file>
              <cube-upload-btn :multiple="false">
                <div class="upload-btn">
                  <i></i>
                  <p>支付凭证1</p>
                </div>
              </cube-upload-btn>
            </div>
          </cube-upload>
          <cube-upload
            class="box-wrap"
            ref="backPpload"
            v-model="auth.file2"
            :auto="false"
            :max="1"
            @files-added="filesAdded"
            @file-success="successFront"
            @file-error="errFront"
          >
            <div class="clearfix">
              <cube-upload-file v-for="(file, i) in auth.file2" :file="file" :key="i"></cube-upload-file>
              <cube-upload-btn :multiple="false">
                <div class="upload-btn">
                  <i></i>
                  <p>支付凭证2</p>
                </div>
              </cube-upload-btn>
            </div>
          </cube-upload>
        </div>
      </div>

      <div class="auth-upload" v-if="order.Status>=2">
          <div class="upload-btn pic">
            <div class="picc">
                  <img :src="order.PayImage1" alt="">
            </div>
          </div>
           <div class="upload-btn pic">
              <div class="picc">
                  <img :src="order.PayImage2" alt="">
            </div>
          </div>
      </div>
      <div class="account-wrap order-buy-desc" v-if="order.Status==1">
        <div class="wrap-item">
          <span class="item-label">备注：</span>
          <input
            type="text"
            v-model="personalRemark"
            placeholder="备注(可不填写)"
          />
        </div>
      </div>

      <div class="order-operation" v-if="order.Status==1">
        <div class="btn-container">
          <div class="btn-item btn-danger" @click="cancel">取消购买</div>  
          <div class="btn-item btn" @click="confirmGet">确认打款</div>
        </div>

        <!-- <div class="tusd-btn" @click="confirmGet">确认打款</div>
        <div class="tusd-btn tusd-btn-danger" @click="cancel">取消购买</div> -->
    
      </div>
    <div class="order-operation nobuttom" v-if="order.Status==5">
      <div class="tusd-btn" @click="goChat(order.ID)">异议处理</div>
    </div>
  </div>
</template>

<script>
export default {
  name: "orderDetails",
  data() {
    return {
      cfmClick: false,
      noClick: false,
      params: {},
      order: {},
      auth: {
        file1: [],
        file2: []
      },
      personalRemark:""
    };
  },
  methods: {
    filesAdded(files) {
      let hasIgnore = false;
      const limitSize = 2 * 1024* 1024;
      // 最大5M
      const maxSize = 5 * 1024 * 1024;
      for (let i = 0; i < files.length; i++) {
        const file = files[i];
        // 如果选择的图片大小最大限制（这里为5M）则弹出提示
        if (file.size > maxSize) {
          file.ignore = true;
          hasIgnore = true;
          break;
        }
        // 如果选择的图片大小大于1M则进行图片压缩处理（Base64）
        if (file.size > limitSize) {
          this.compressPic(file);
        } else {
          let reads = new FileReader();
          reads.readAsDataURL(file);
          let that = this;
          reads.onload = function(e) {
            var bdata = this.result;
            file.base64 = bdata;
          };
        }
      }
      hasIgnore &&
        this.$createToast({
          type: "warn",
          time: 1000,
          txt: "图片最大支持5M"
        }).show();
    },
    // 图片压缩方法
    compressPic(file) {
      let reads = new FileReader();
      reads.readAsDataURL(file);
      // 注意这里this作用域的问题
      let that = this;
      reads.onload = function(e) {
        var bdata = this.result;
        // 这里quality的范围是（0-1）
        var quality = 0.5;
        var canvas = document.createElement("canvas");
        var ctx = canvas.getContext("2d");
        var img = new Image();
        img.src = bdata;
        img.onload = function() {
          var width = img.width;
          canvas.width = width;
          canvas.height = width * (img.height / img.width);
          ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
          let data = canvas.toDataURL("image/jpeg", quality);
          file.base64 = data;
        };
      };
    },
    filesRemoved() {
    },
    successFront() {
    },
    errFront() {},
    getOrderDetail(orderId) {
      let that=this;
      that.$api.getOrderDetail(orderId).then(res => {
        that.order = res.data;
      });
    },
     copySuccess() {
      this.$message.popup("复制成功", 1000);
    },
    copyError() {
      this.$message.popup("复制失败", 1000);
    },
    goChat(orderId){
        let name = 'chat',that=this;
          that.$store.commit('storeParams',{
                  name:name,
                  back:"",
                  orderId:orderId
              })
          that.$router.push({name:name})
    },
    goBack(type) {
      let that = this;
      let crtIndex = this.params.crtIndex;
      if (type !== 0) {
        crtIndex = type;
      }
      that.$router.push({
        name: that.params.back,
        params: {
          crtIndex: crtIndex
        }
      });
    },
    confirmGet() {
      let that = this;
      if (that.auth.file1.length<=0&&that.auth.file2.length<=0) {
        that.$message.popup("请上传一张支付凭证", 1000);
        return;
      }
      let data = {
        orderId: this.order.ID,
        pic1:that.auth.file1.length>0?that.auth.file1[0].file.base64:"",
        pic2:that.auth.file2.length>0?that.auth.file2[0].file.base64:"",
        personalRemark:this.personalRemark
      };

      that.$message.confirm("提示", "您确定打款了？", () => {
        that.$api.confirmPayOrder(data).then(res => {
            that.$message.popup("确认打款成功", 1000);
          // 弹出框之后跳回去
            that.goBack(3);
        });
      });
    },
    cancel(){//取消打款
      let that = this;
        let data = {
          orderId: this.order.ID
        };
        that.$message.confirm("提示", "您确定取消订单吗？", () => {
          that.$api.cancelPayOrder(data).then(res => {
              that.$message.popup("取消成功", 1000);
            // 弹出框之后跳回去
              that.goBack(3);
          });
      });
    }
  },
  created() {
    this.params = this.$store.state.routerStore.orderbuyDetail;
    this.getOrderDetail(this.params.orderId);
  }
};
</script>

<style lang="less" scoped>
.order-scroll{
		height: calc(100% - 115px);
	}
.cube-scroll-wrapper{
  height: auto;
}

.order-details {
  position: relative;
  padding: 20px 14px;
  .user-order {
    display: flex;
    align-items: center;
    float: left;
    width: 50%;
    .user-header {
      .header-wrap {
        width: 42px;
        height: 42px;
        margin-right: 16px;
        background: url(../assets/images/header.png) center center no-repeat;
        background-size: cover;
        border-radius: 20px;
      }
    }
    .order-amount {
      margin-bottom: 10px;
      font-size: 16px !important;
      color: #d9e3fd;
    }
    .order-time {
      span {
        display: inline-block;
        font-size: 12px !important;
        color: #96abe4;
      }
    }
  }
  .order-money {
    float: right;
    max-width: 50%;
    .order-money-title {
      margin-bottom: 10px;
      font-size: 16px !important;
      color: #d9e3fd;
    }
    .order-money-amount {
      font-size: 14px !important;
      color: #96abe4;
      span {
        margin-right: 10px;
        font-size: 22px !important;
        color: #28faff;
      }
    }
  }
}
.order-operation {
  margin: 10px 14px 12px;
  padding-bottom: 26px;
  // border-bottom: 1px solid rgba(76, 89, 145, 0.6);
  &.nobuttom{
       border-bottom:none;
  }
}
.notice {
  padding: 0px 14px 16px;
  color: #575f8d;
  font-size: 12px !important;
  line-height: @notice-height;
}

.order-buy-desc {
  padding: 0;
  .wrap-item {
    padding-left: 14px;
    padding-right: 14px;
  }
}

.auth-upload {
  padding: 14px 14px 5px 14px;
 overflow: hidden;
  .upload-title {
    font-size: 15px !important;
    color: #d9e3fd;
  }
  .upload-wrap {
    display: flex;
    justify-content: space-between;
    margin-top: 20px;
    .box-wrap {
      width: 48.5%;
      height: 110px;
      padding: 0px;
      .upload-btn {
        padding-top: 14%;
        text-align: center;
        &.pic{
           float: left;
           width: 50%;
         }
        i {
          display: inline-block;
          width: 30px;
          height: 30px;
          background: url(../assets/images/add.svg) center center no-repeat;
        }
        p {
          padding-top: 10px;
          color: #8092c6;
        }
      }

    }
  }
  .upload-notice {
    margin: 14px 0px 36px;
    font-size: 12px !important;
    color: #575f8d;
    line-height: @notice-height;
  }
  .personal-remark{
    font-size: 15px !important;
    color: #d9e3fd;
    border-bottom:"1px solid rgba(76, 89, 145, 0.6)" ;
  }
}
@media screen and (min-width: 380px) {
  .auth-upload {
    .upload-wrap {
      .box-wrap {
        height: 120px;
      }
    }
  }
}
@media screen and (max-width: 370px) {
  .auth-upload {
    .upload-wrap {
      .box-wrap {
        height: 105px;
      }
    }
  }
}
@media screen and (max-width: 320px) {
  .auth-upload {
    .upload-wrap {
      .box-wrap {
        height: 94px;
        .upload-btn {
          p {
            font-size: 13px !important;
          }
        }
      }
    }
  }
}
</style>
<style lang="less">
.cube-popup-center .cube-popup-content {
  padding: 12px 30px;
  border-radius: 3px;
  color: #fff;
  background: rgba(0, 0, 0, 0.4);
}
.cube-dialog-icon i {
  width: auto;
  height: auto;
}
.upload-btn.pic{
      float: left;
      width: 50%;
      .picc{
        width: 100%;
        margin: 0 auto;
        text-align: center;
        color: #8092c6;
        img{
          max-width: 150px;
          margin: 0 auto;
          margin-bottom: 15px;
        }
        p{
          font-size: 12px !important
        }
      }
}
.cube-upload-btn {
    position: absolute;
    overflow: hidden;
    width: 100%;
    top: 2%;
}
.order_icon{
			width: 38px;
			height: 38px;
			margin-right: 15px;
			border-radius: 50px;
		}

</style>
